var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row margin-top" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-8 offset-2 background" }, [
        _c(
          "form",
          {
            attrs: { autocomplete: "no" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.update($event)
              },
              keydown: function($event) {
                _vm.clearError($event)
              }
            }
          },
          [
            _c("div", { staticClass: "form-row padding-bottom" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.info.first_name,
                        expression: "info.first_name"
                      }
                    ],
                    staticClass: "form-control login-input",
                    attrs: {
                      id: "first_name",
                      name: "first_name",
                      type: "text",
                      placeholder: "Name"
                    },
                    domProps: { value: _vm.info.first_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.info, "first_name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "first_name" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.info.last_name,
                        expression: "info.last_name"
                      }
                    ],
                    staticClass: "form-control login-input",
                    attrs: {
                      id: "last_name",
                      name: "last_name",
                      type: "text",
                      placeholder: "Last name"
                    },
                    domProps: { value: _vm.info.last_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.info, "last_name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "last_name" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row padding-bottom" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info.password,
                          expression: "info.password"
                        }
                      ],
                      staticClass: "form-control login-input",
                      attrs: {
                        id: "password",
                        type: "password",
                        name: "password",
                        placeholder: "Password"
                      },
                      domProps: { value: _vm.info.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.info, "password", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(1)
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "password" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.info.password_confirmation,
                        expression: "info.password_confirmation"
                      }
                    ],
                    staticClass: "form-control login-input",
                    attrs: {
                      id: "password_confirmation",
                      name: "password_confirmation",
                      type: "password",
                      placeholder: "Confirm password"
                    },
                    domProps: { value: _vm.info.password_confirmation },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.info,
                          "password_confirmation",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: {
                      errors: _vm.errors,
                      field: "password_confirmation"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "btn btn-primary form-control login-button",
              attrs: {
                type: "submit",
                value: "Register",
                disabled: _vm.errors.any()
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 offset-2" }, [
      _c("div", { staticClass: "row medium-font" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("a", { attrs: { href: "#" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 text-center" }, [
          _c("h3", [_c("strong", [_vm._v("Grow your business with mod24")])])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row big-font" }, [
        _c("div", { staticClass: "col text-center" }, [
          _c("p", [
            _c("strong", [
              _vm._v(
                "\n              Email address has been verified\n              "
              ),
              _c("br"),
              _vm._v(
                "\n              Lets complete the profile setup\n            "
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fa fa-question-circle-o popup" })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { display: "none", "align-content": "flex-start" },
          attrs: { id: "myTemplate" }
        },
        [
          _c("p", [_vm._v("Password must meet the following criteria:")]),
          _vm._v(" "),
          _c("ul", { staticClass: "text-left" }, [
            _c("li", [_vm._v("8 characters long")]),
            _vm._v(" "),
            _c("li", [_vm._v("1 uppercase letter")]),
            _vm._v(" "),
            _c("li", [_vm._v("1 lowercase letter")]),
            _vm._v(" "),
            _c("li", [_vm._v("1 number")])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 offset-2" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col text-right" }, [
          _c("a", { staticClass: "thick-font", attrs: { href: "#" } }, [
            _vm._v("Need help?")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticClass: "info-text" }, [
            _vm._v("Visit our knowledge base")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62e26950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e26950","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Update.vue
// module id = null
// module chunks = 